import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const TechnicalRegulationsOfCustomsUnionList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="technicalRegulationsOfCustomsUnion"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default TechnicalRegulationsOfCustomsUnionList;
